import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

interface UploadResponse {
  success: boolean;
  message: string;
  data?: {
    files: Array<{
      filename: string;
      path: string;
      url: string;
    }>;
    booking_id: number;
  };
  errors?: { [key: string]: string[] };
  error?: string;
}

interface TokenVerifyResponse {
  success: boolean;
  message: string;
  data?: {
    booking_id: number;
    expires_at: string;
    email: string;
  };
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PodUploadService {

  constructor(private http: HttpClient) {}

  verifyToken(token: string): Observable<TokenVerifyResponse> {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    return this.http.get<TokenVerifyResponse>(
      `${environment.domain}/${environment.apiVersion}/pod-upload/${token}/verify`,
      { headers }
    );
  }

  uploadFiles(token: string, files: File[], documentType: 'collection' | 'delivery'): Observable<UploadResponse> {
    const formData = new FormData();
    
    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });
    
    formData.append('document_type', documentType);

    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    return this.http.post<UploadResponse>(
      `${environment.domain}/${environment.apiVersion}/pod-upload/${token}`,
      formData,
      { headers }
    );
  }
}